export default (state, { payload: { isPriority } }) => ({
  ...state,
  isPriority
});
